export default {
  metrics: {
    pickup: 'Levantamento',
    internal_delivery: 'Entrega interna',
    external_delivery: 'Entrega externa',
  },
  events: {
    add_to_basket: 'Adicionar item',
    begin_checkout: 'Avançar para checkout',
    begin_purchase: 'Iniciar pagamento',
    complete_purchase: 'Concluir pagamento',
    order_placed: 'Concluir pagamento',
    view_item: 'Ver item',
  },
};
